<nb-card>
  <nb-card-body>
    <div class="qrcodeImage">
      <!-- <qrcode [qrdata]="qrdata" [errorCorrectionLevel]="'M'"> </qrcode> -->
      <qrcode
        [qrdata]="qrdata"
        [allowEmptyString]="true"
        [cssClass]="'center'"
        [elementType]="'canvas'"
        [errorCorrectionLevel]="'M'"
        [margin]="4"
        [scale]="1"
        [title]="title"
        [width]="150"
      >
      </qrcode>
    </div>
  </nb-card-body>
</nb-card>
